import { IconButton, List, Popover } from '@material-ui/core';
import { MoreVert } from '@material-ui/icons';
import React, { useState } from 'react';

const ListMoreButtonMenu: React.FC = ({ children }) => {
  const [menuAnchor, setMenuAnchor] = useState<HTMLButtonElement>();
  return (
    <>
      <IconButton
        size='small'
        color='secondary'
        onClick={event => setMenuAnchor(event.currentTarget)}
      >
        <MoreVert />
      </IconButton>
      {menuAnchor && (
        <Popover
          open
          anchorEl={menuAnchor}
          onClose={() => setMenuAnchor(undefined)}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
          <List onClick={() => setMenuAnchor(undefined)}>{children}</List>
        </Popover>
      )}
    </>
  );
};

export default ListMoreButtonMenu;
